import {
	DatePicker,
	type RangePickerProps,
} from "components/DatePicker/DatePicker"
import { Dayjs, today } from "utils/date"

export function RangeFilter({
	label,
	presets,
	format,
	maxDate,
	...props
}: RangePickerProps & { label: string }) {
	return (
		<div
			role="group"
			aria-label={label}
			className="flex min-w-lg items-center gap-1"
		>
			<div className="text-nowrap">{label}</div>
			<DatePicker.RangePicker
				{...props}
				presets={presets ?? DEFAULT_PRESETS}
				format={format ?? "YYYY/MM/DD"}
				maxDate={maxDate ?? today()}
			/>
		</div>
	)
}

const getDateRangeFromToday = (diffDays: number): [Dayjs, Dayjs] => {
	const now = today()
	return [now.add(diffDays, "d"), now]
}

const DEFAULT_PRESETS: NonNullable<RangePickerProps["presets"]> = [
	{
		label: <span aria-label="Current time to end of day">Now ~ EOD</span>,
		value: () => {
			const now = today()
			return [now, now.endOf("day")]
		},
	},
	{ label: "Last day", value: () => getDateRangeFromToday(-1) },
	{ label: "Last 7 days", value: () => getDateRangeFromToday(-7) },
	{ label: "Last 14 days", value: () => getDateRangeFromToday(-14) },
	{ label: "Last 30 days", value: () => getDateRangeFromToday(-30) },
	{ label: "Last 90 days", value: () => getDateRangeFromToday(-90) },
]
